import React, { useState } from 'react';

import Loader from 'react-loader-spinner';
import { useParams, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../firebase';
import ModalConfirm from '../useful/ModalConfirm';


const PlayerListItem = (props) => {

    const { tournament_uid, team_uid } = useParams(); // tournament and team uid
    const userId = props.firebase.auth.currentUser.uid; // user auth uid

    const { item, disabled, showPlayerForm, playerUidList } = props;
    const [deleting, setDeleting] = useState(false);
    const [confirmModal, setConfirmModal] = useState({ show: false, title: '', message: '' });

    const deleteItem = () => {
        setConfirmModal({ show: false, title: '', message: '' });
        if (!disabled) {
            // setConfirmModal({ show: false, title: '', message: '' });
            // setDeleting(true);
            try {

                const batch = props.firebase.batch();
                batch.delete(props.firebase.playerDoc(userId, tournament_uid, item.uid))

                const list = playerUidList.filter(p => p !== item.uid)
                batch.update(props.firebase.teamDoc(userId, tournament_uid, team_uid), { players: JSON.stringify(list) });

                batch.commit().then(() => {
                    setDeleting(false);
                }).catch(error => {
                    console.log("Error: ", error);
                    setDeleting(false);
                    props.showModal("Error", "No se pudo eliminar el jugador: " + item.name);
                });
            } catch (error) {
                setDeleting(false);
                console.log("Error: ", error);
                props.showModal("Error", "No se pudo eliminar el jugador: " + item.name);
            }
        }
    }

    const showConfirmModal = () => {
        setConfirmModal({ show: true, title: 'Eliminar Jugador', message: 'Está seguro de eliminar el jugador: ' + item.name });
    }

    const editPlayer = () => {
        showPlayerForm(item);
    }

    // const playerLogo = (item && item.logoUrl) ? item.logoUrl : process.env.PUBLIC_URL + "/player_logo.png"
    const playerLogo = (item && item.logoUrl) ?
        item.logoUrl
        :
        item.position !== "Director Técnico" ?
            process.env.PUBLIC_URL + "/shirt.png"
            :
            process.env.PUBLIC_URL + "/player_logo.png"

    return (
        <tr className="bg-hover-td">
            {/* <td className="align-middle text-center" onClick={editPlayer} scope="row" >{item.number || '-'}</td> */}
            <td className="align-middle text-right pl-1 pr-1" onClick={editPlayer} >
                <div className="d-flex justify-content-center align-items-center" style={{
                    backgroundImage: `url(${playerLogo})`,
                    height: 30,
                    width: 32,
                    minWidth: 30,
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat'
                }} >
                    <span className="font-weight-bold" style={{ fontSize: 12 }}>
                        {item.position !== "Director Técnico" && (item.number || '-')}
                    </span>
                </div>
            </td>
            <td className="align-middle font-weight-bold" onClick={editPlayer} >{item.name}</td>
            <td className="align-middle text-center d-none d-md-table-cell " onClick={editPlayer} >{item.dni}</td>
            <td className="align-middle text-center" onClick={editPlayer} >{item.position || '-'}</td>
            <th className="align-middle">
                <div className="nav justify-content-center">
                    {(!deleting) ?
                        <button disabled={disabled} onClick={showConfirmModal} className="btn btn btn-link text-danger p-2 m-0" data-toggle="tooltip" data-placement="bottom" title="Eliminar">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                        :
                        <Loader className="m-1"
                            type="ThreeDots"
                            color="#263238"
                            height={30}
                            width={40}
                            timeout={0} />
                    }
                </div>
            </th>

            <ModalConfirm
                data={confirmModal}
                onClose={() => setConfirmModal({ show: false, title: '', message: '' })}
                onConfirm={deleteItem}
            />

        </tr >
    )


}

export default withRouter(withFirebase(PlayerListItem));
